module.exports = __webpack_public_path__ + "img/shapes.66c5dee7.png";